var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 3.90625C11.4646 3.90625 10.4711 4.3178 9.73852 5.05036C9.00595 5.78293 8.5944 6.7765 8.5944 7.8125C8.5944 8.8485 9.00595 9.84207 9.73852 10.5746C10.4711 11.3072 11.4646 11.7188 12.5007 11.7188C13.5367 11.7188 14.5302 11.3072 15.2628 10.5746C15.9954 9.84207 16.4069 8.8485 16.4069 7.8125C16.4069 6.7765 15.9954 5.78293 15.2628 5.05036C14.5302 4.3178 13.5367 3.90625 12.5007 3.90625ZM8.33398 13.8021C7.29798 13.8021 6.30441 14.2136 5.57185 14.9462C4.83928 15.6788 4.42773 16.6723 4.42773 17.7083V18.9458C4.42773 19.7313 4.99648 20.4 5.77148 20.526C10.2277 21.2542 14.7736 21.2542 19.2298 20.526C19.6049 20.465 19.946 20.2725 20.1922 19.983C20.4384 19.6935 20.5736 19.3259 20.5736 18.9458V17.7083C20.5736 16.6723 20.162 15.6788 19.4295 14.9462C18.6969 14.2136 17.7033 13.8021 16.6673 13.8021H16.3132C16.1204 13.8021 15.9288 13.8333 15.7465 13.8917L14.8444 14.1865C13.3214 14.6836 11.6799 14.6836 10.1569 14.1865L9.25482 13.8917C9.07217 13.8322 8.88127 13.802 8.68919 13.8021H8.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/User_icon.da6c447373d14c0829a69b19e5bed673.svg";
export { ForwardRef as ReactComponent };